import type { ReactNode } from 'react';
import { Page, PageHeader } from '@ampm-7en-ai/ui/components/Page';

/**
 * The frame every redesigned platform settings page sits in.
 *
 * Deliberately separate from the classic layout rather than a replacement for
 * it: both interfaces are live, and restyling the shared one would drag the
 * classic pages along with it.
 */
export default function PlatformSettingsLayoutV2({
  children,
  title,
  description,
  actions,
}: {
  children: ReactNode;
  title: string;
  description?: string;
  /** Anything the page wants beside its title, e.g. a primary action. */
  actions?: ReactNode;
}) {
  return (
    <Page>
      <PageHeader title={title} description={description} actions={actions} />
      {children}
    </Page>
  );
}
